import { Dialog, IAssetParameterValue } from "@models";


export class Utility {
  public static previewFileInModalDialog(
    file: File,
    filePreview: Dialog,
    previewPath: string,
    value?: IAssetParameterValue,
  ): void {
    if (file && file.size > 0) {
      var url = URL.createObjectURL(file);
      filePreview.values[0].value = url;
      filePreview.ok = () => {
        var a = document.createElement("a");
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
    } else {
        if (value) {
            // Show preview of video file stored in Azure
            filePreview.values[0].value = `${previewPath}${value.AssetPath}?v=${Date.now()}`;
            filePreview.ok = () => {
                var url = `${previewPath}${value.AssetPath}`;
                fetch(url)
                    .then(resp => resp.blob())
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        a.download = value.UploadedFilename;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(() => window.open(url, "_self"));                
                };
        }
    }

     filePreview.visible = (file && file.size > 0) || !!value;
  }
}
